import { Component, Inject, Input, forwardRef } from '@angular/core';
import { NgbModal }        from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';
import { TemplateModel }   from '../templates/typings/template';

import { CompanyListsTemplateComponent } from './company-lists.template.component';

@Component({
  selector: 'wor-company-lists-templates',
  template: require('./company-lists.templates.component.html')
})
export class CompanyListsTemplatesComponent {
  @Input() templates: Array<TemplateModel> = [];
  @Input() title: string;
  @Input() type: string;

  collapsed = false;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService: ConfirmService,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    private modalService: NgbModal,
    private translateService: TranslateService
  ) {}

  viewTemplate(index?: number): void {
    const isEdit = index !== undefined && index !== null;

    const modalRef = this.modalService.open(CompanyListsTemplateComponent, { windowClass: 'lg-modal' });
    modalRef.componentInstance.template = isEdit
      ? { ...this.templates[index] }
      : { wording_type: this.type };

    modalRef.result
      .then((template: TemplateModel) => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.TEMPLATE'), 'success');

        if (isEdit) {
          this.templates[index] = template;
        } else {
          this.templates.push(template);
        }
      })
      .catch(() => {});
  }

  deleteTemplate(index: number, evt?: Event): void {
    if (evt) {
      evt.stopPropagation();
    }

    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_TEMPLATE'))
      .then(() => this.apiService.delete('/templated_wording', this.templates[index].id))
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.TEMPLATE'), 'success');
        this.templates.splice(index, 1);
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }
}
